import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
export default function Cases(){
    const [cases, setCases] = useState([]);
    const [editingCases, setEditingCase] = useState(null);

    // Fetch all chambers
      useEffect(() => {
        fetchCases();
      }, []);

    const fetchCases = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CaseMaster/GetCasebyemail`, {
          headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setCases(data);
      } else {
        console.error("Failed to fetch chamber");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Delete court
  const handleDeleteCases = async (id) => {
    if (!window.confirm("Are you sure you want to delete this case?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setCases((prev) => prev.filter((c) => c.id !== id));
        alert("Case deleted successfully!");
      } else {
        console.error("Failed to delete case");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update court
  const handleUpdateCases = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CaseMaster/update/${editingCases.caseId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingCases),
      });
      if (res.ok) {
        fetchCases();
        setEditingCase(null);
        alert("Case updated successfully!");
      } else {
        console.error("Failed to update case");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };


return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Case</h2>      
 
      {/* Court Table */}
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Case No</th>
            <th>Advocate</th>
            <th>Court</th>
            <th>Chamber</th>
            <th>Petitoner</th>
            <th>Status</th>
            <th>Filling Date</th>
            <th>Hearing Date</th>
            <th>Next Hearing</th>
            <th>Remark</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {cases.length > 0 ? (
            cases.map((cases) => (
              <tr key={cases.caseId}>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.caseNumber}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, caseNumber: e.target.value })
                      }
                    />
                  ) : (
                    cases.caseNumber
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.advocateName}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, advocateName: e.target.value })
                      }
                    />
                  ) : (
                    cases.advocateName
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.courtName}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, courtName: e.target.value })
                      }
                    />
                  ) : (
                    cases.courtName
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.chamberName}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, chamberName: e.target.value })
                      }
                    />
                  ) : (
                    cases.chamberName
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.partyName}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, partyName: e.target.value })
                      }
                    />
                  ) : (
                    cases.partyName
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.caseStatus}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, caseStatus: e.target.value })
                      }
                    />
                  ) : (
                    cases.caseStatus
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.filingDate}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, filingDate: e.target.value })
                      }
                    />
                  ) : (
                    cases.filingDate
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.hearingDate}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, hearingDate: e.target.value })
                      }
                    />
                  ) : (
                    cases.hearingDate
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.nextHearingDate}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, nextHearingDate: e.target.value })
                      }
                    />
                  ) : (
                    cases.nextHearingDate
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <input
                      type="text"
                      value={editingCases.remarks}
                      onChange={(e) =>
                        setEditingCase({ ...editingCases, remarks: e.target.value })
                      }
                    />
                  ) : (
                    cases.remarks
                  )}
                </td>
                <td>
                  {editingCases?.caseId === cases.caseId ? (
                    <>
                      <button onClick={handleUpdateCases}>Save</button>
                      <button onClick={() => setEditingCase(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditingCase(cases)}>Edit</button>
                      <button onClick={() => handleDeleteCases(cases.caseId)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No Case found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

        
